"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: common/user-risk-evaluation.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcommon%2Fuser-risk-evaluation.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskEvaluationExplanation = exports.RiskEvaluationFeatureExplanation = exports.RiskEvaluation = void 0;
const protobufPackage = 'com.step.common.proto';
function createBaseRiskEvaluation() {
    return { referenceId: '', score: 0, explanation: undefined };
}
exports.RiskEvaluation = {
    fromJSON(object) {
        const message = {
            referenceId: isSet(object.referenceId) ? globalThis.String(object.referenceId) : '',
            score: isSet(object.score) ? globalThis.Number(object.score) : 0,
        };
        if (isSet(object.explanation)) {
            message.explanation = exports.RiskEvaluationExplanation.fromJSON(object.explanation);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.referenceId !== '') {
            obj.referenceId = message.referenceId;
        }
        if (message.score !== 0) {
            obj.score = message.score;
        }
        if (message.explanation !== undefined) {
            obj.explanation = exports.RiskEvaluationExplanation.toJSON(message.explanation);
        }
        return obj;
    },
    create(base) {
        return exports.RiskEvaluation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRiskEvaluation();
        message.referenceId = object.referenceId ?? '';
        message.score = object.score ?? 0;
        message.explanation = (object.explanation !== undefined && object.explanation !== null)
            ? exports.RiskEvaluationExplanation.fromPartial(object.explanation)
            : undefined;
        return message;
    },
};
function createBaseRiskEvaluationFeatureExplanation() {
    return {
        name: '',
        valueInt32: undefined,
        valueInt64: undefined,
        valueFloat32: undefined,
        valueFloat64: undefined,
        valueBool: undefined,
        shapleyValue: 0,
        description: '',
    };
}
exports.RiskEvaluationFeatureExplanation = {
    fromJSON(object) {
        const message = {
            name: isSet(object.name) ? globalThis.String(object.name) : '',
            shapleyValue: isSet(object.shapleyValue) ? globalThis.Number(object.shapleyValue) : 0,
            description: isSet(object.description) ? globalThis.String(object.description) : '',
        };
        if (isSet(object.valueInt32)) {
            message.valueInt32 = globalThis.Number(object.valueInt32);
        }
        if (isSet(object.valueInt64)) {
            message.valueInt64 = globalThis.String(object.valueInt64);
        }
        if (isSet(object.valueFloat32)) {
            message.valueFloat32 = globalThis.Number(object.valueFloat32);
        }
        if (isSet(object.valueFloat64)) {
            message.valueFloat64 = globalThis.Number(object.valueFloat64);
        }
        if (isSet(object.valueBool)) {
            message.valueBool = globalThis.Boolean(object.valueBool);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.name !== '') {
            obj.name = message.name;
        }
        if (message.valueInt32 !== undefined) {
            obj.valueInt32 = Math.round(message.valueInt32);
        }
        if (message.valueInt64 !== undefined) {
            obj.valueInt64 = message.valueInt64;
        }
        if (message.valueFloat32 !== undefined) {
            obj.valueFloat32 = message.valueFloat32;
        }
        if (message.valueFloat64 !== undefined) {
            obj.valueFloat64 = message.valueFloat64;
        }
        if (message.valueBool !== undefined) {
            obj.valueBool = message.valueBool;
        }
        if (message.shapleyValue !== 0) {
            obj.shapleyValue = message.shapleyValue;
        }
        if (message.description !== '') {
            obj.description = message.description;
        }
        return obj;
    },
    create(base) {
        return exports.RiskEvaluationFeatureExplanation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRiskEvaluationFeatureExplanation();
        message.name = object.name ?? '';
        message.valueInt32 = object.valueInt32 ?? undefined;
        message.valueInt64 = object.valueInt64 ?? undefined;
        message.valueFloat32 = object.valueFloat32 ?? undefined;
        message.valueFloat64 = object.valueFloat64 ?? undefined;
        message.valueBool = object.valueBool ?? undefined;
        message.shapleyValue = object.shapleyValue ?? 0;
        message.description = object.description ?? '';
        return message;
    },
};
function createBaseRiskEvaluationExplanation() {
    return { score: 0, shapleyBaselineValue: 0, contributions: [] };
}
exports.RiskEvaluationExplanation = {
    fromJSON(object) {
        const message = {
            score: isSet(object.score) ? globalThis.Number(object.score) : 0,
            shapleyBaselineValue: isSet(object.shapleyBaselineValue)
                ? globalThis.Number(object.shapleyBaselineValue)
                : 0,
            contributions: globalThis.Array.isArray(object?.contributions)
                ? object.contributions.map((e) => exports.RiskEvaluationFeatureExplanation.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.score !== 0) {
            obj.score = message.score;
        }
        if (message.shapleyBaselineValue !== 0) {
            obj.shapleyBaselineValue = message.shapleyBaselineValue;
        }
        if (message.contributions?.length) {
            obj.contributions = message.contributions.map((e) => exports.RiskEvaluationFeatureExplanation.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.RiskEvaluationExplanation.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseRiskEvaluationExplanation();
        message.score = object.score ?? 0;
        message.shapleyBaselineValue = object.shapleyBaselineValue ?? 0;
        message.contributions =
            object.contributions?.map((e) => exports.RiskEvaluationFeatureExplanation.fromPartial(e)) || [];
        return message;
    },
};
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=user-risk-evaluation.js.map